import { useAuthStore } from "@/stores/authStore";
import EmployerUpdateRequestForm from "@/components/employer-update-request/EmployerUpdateRequestForm";
import type { User } from "@/models/responses/auth/user.response";

/**
 * Authenticated (settings/profile area) entry point for the employer update
 * request flow. Current values come from the authenticated employer
 * profile rather than onboarding tempData.
 */
const EmployerUpdateRequestPage = () => {
  const currentEmployer = useAuthStore(
    (state) => state.currentEmployer as User | null
  );

  const authorizedContact = currentEmployer?.authorizedContact as
    | { email?: string; phoneNumber?: string; role?: string }
    | undefined;

  return (
    <EmployerUpdateRequestForm
      context="authenticated"
      employerCode={currentEmployer?.employerCode ?? ""}
      currentName={currentEmployer?.companyName}
      currentRcNumber={currentEmployer?.rcNumber}
      currentAddress={currentEmployer?.companyAddress}
      currentEmail={currentEmployer?.user?.email}
      currentPhone={currentEmployer?.user?.phoneNumber}
      currentContactPersonEmail={authorizedContact?.email}
      currentContactPersonPhone={authorizedContact?.phoneNumber}
      currentContactPersonRole={authorizedContact?.role}
      contactEmailDefault={currentEmployer?.user?.email}
    />
  );
};

export default EmployerUpdateRequestPage;
